export class OptimaxDriveContext {
    odc_id: string;
    odc_drive: string;
    odc_context_libelle: string;
    odc_context_type: string;
    odc_context_id: string;
    odc_resource_type: string;
    odc_resource_id: string;

    constructor(init?: Partial<OptimaxDriveContext>) {
        Object.assign(this, init);
    }
}
